<script setup lang="ts">
// types
import type { SectionTutorsProps } from '@ts-sections/section-tutors/interfaces'
// hooks
import { useSectionTutors } from '@hooks/sections/section-tutors.hook'
// components
import { SectionLayout } from '@UI/Layouts/SectionLayout'
import { CardSlider } from '@UI/Sliders/CardSlider'
import BlockTutorCard from '@Blocks/BlockTutorCard.vue'

defineOptions({
  name: 'SectionTutors',
})

const props = defineProps<{
  section: SectionTutorsProps
}>()

const {
  refTitle,
  refDescription,
  refBackgroundColor,
  getCardMotion,
  handleClickPrev,
  handleClickNext,
} = useSectionTutors({
  section: () => props.section,
})
</script>

<template>
  <SectionLayout
    class="section-tutors"
    :data-component="section.__component"
    :title="refTitle"
    :title-tag="section.layout?.titleTag"
    :description="refDescription"
    :color="refBackgroundColor"
    :space="section.layout?.space"
  >
    <CardSlider
      class="section-tutors__slider"
      prev-label="Previous tutors"
      next-label="Next tutors"
      @click:prev="handleClickPrev"
      @click:next="handleClickNext"
    >
      <div
        v-for="(tutor, index) in section.tutors"
        :key="tutor.id ?? index"
        v-motion="getCardMotion(index)"
        class="section-tutors__item"
      >
        <BlockTutorCard :block="tutor" />
      </div>
    </CardSlider>
  </SectionLayout>
</template>

<style scoped lang="scss" src="@scss/components/Sections/SectionTutors.scss" />
